module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAUCAQAAAAngNWGAAAAAXNSR0IArs4c6QAAAU1JREFUKM9jYBgcIEUztSg9Me1B2uu00vTkjGicCtMepu1J+50SkmqQ9i71SNrTVHtcCl9nGCYIgFi5fAkcac8zDHEoTK9JO5thnWoFhpPSD+K2Ojvtd9p1CEx9kHYzXQurstTetIcZZkjaytLepBpgWluUdjdFBii9O8OagTFtSnockJ2T9iRZCEVZskra5xQ9sLkRae/S16VdjBMGa1+ZNg3VdZNTp4PoBI70XqAL/6etSg8CiyunfUvjQlZ4O90ORDewpJakzUt7BvS/I1TmfIotssIfSVIgOosn7Tww2L8DfV0D9eK61GBkhS+zVCCsDMP03LRbqVYJElCF+1NckRWuSWuAx7he2nq4uEbqlzQRlOSQ9iZtRrpHumqKeJxwnHCGWIpiii3Qpa9TS9DCMUcKGOBn096m/Ur7l/YX6Nf3aVfT56fZ0C6tAgBOuoC8wyTmvQAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/open/leftbar_icon_record_n.png
// module id = P77O
// module chunks = 1